var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_655_3882)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9316 25.4439C24.8141 25.4943 24.6293 25.6119 24.5285 25.7127C24.0666 26.141 24.0918 24.898 24.0918 44.3824V62.4223L24.2682 62.7918C24.3773 63.0102 24.5873 63.2453 24.7889 63.3797L25.1332 63.6064H44.5H63.8668L64.2111 63.3797C64.4127 63.2453 64.6227 63.0102 64.7318 62.7918L64.9082 62.4223V49.2535C64.9082 37.2773 64.8998 36.0596 64.7738 35.7992C64.4967 35.2197 63.7408 34.9426 63.1445 35.2029C62.985 35.2785 59.8523 37.966 56.1822 41.1742C50.1941 46.4232 49.4887 47.0195 49.2367 47.0195C49.0604 47.0195 48.884 46.9523 48.7832 46.8516C48.6152 46.6836 48.6152 46.5744 48.6152 41.485C48.6152 37.8316 48.59 36.2107 48.5229 36.0092C48.2709 35.2533 47.4227 34.8838 46.7508 35.2281C46.6164 35.2953 43.6182 37.8736 40.0992 40.9559C36.5887 44.0297 33.582 46.65 33.4309 46.7844C33.0613 47.0951 32.6498 47.1035 32.4146 46.8012C32.2383 46.5744 32.2383 46.566 32.2383 36.4375V26.3006L32.0535 26.0234C31.9443 25.8723 31.7512 25.6623 31.6252 25.5699C31.39 25.402 31.2893 25.3936 28.2658 25.3768C26.3006 25.3684 25.066 25.3936 24.9316 25.4439ZM43.8281 52.0418C43.9877 52.1174 44.2061 52.3105 44.3068 52.4701C44.5 52.7557 44.5 52.7893 44.5 55.4348C44.5 58.5002 44.4916 58.559 43.8785 58.8613C43.5426 59.0209 43.3746 59.0293 40.4016 59.0293C36.933 59.0293 36.8322 59.0125 36.5215 58.5086C36.3619 58.2482 36.3535 58.0887 36.3535 55.4768C36.3535 53.2344 36.3787 52.6801 36.4711 52.4869C36.6055 52.235 36.8826 52.025 37.1514 51.9494C37.2437 51.9326 38.7219 51.9074 40.4268 51.899C43.2318 51.8906 43.5594 51.9074 43.8281 52.0418ZM60.3143 52.0838C60.835 52.4281 60.835 52.4113 60.835 55.4684C60.835 59.3568 61.2045 59.0293 56.7617 59.0293C53.2932 59.0293 53.2512 59.0209 52.8648 58.5002C52.6969 58.2734 52.6885 58.1391 52.6633 55.6867C52.6465 54.2674 52.6633 52.9908 52.6885 52.8396C52.7557 52.4785 53.1 52.0754 53.4275 51.983C53.5787 51.9326 55.0904 51.9074 56.8877 51.9158C59.7852 51.9326 60.1043 51.9494 60.3143 52.0838Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_3882",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfraIcon);
export default __webpack_public_path__ + "static/media/infraIcon.e513c2ba7ae1c576e9e4aac5d1c913c4.svg";
export { ForwardRef as ReactComponent };